import React from "react";
import { StatusInfo } from "./Interfaces";

interface IStatusIconProps {
    info: StatusInfo;
    diameter?: number;
    displayInline?: boolean;
    // Doubles the icon as a task expander (ticket 1034): a minus when the task is open, a plus
    // when it is closed. Omitted leaves the icon a plain status dot.
    expandState?: "expanded" | "collapsed";
}
export default function StatusIcon({ info, diameter = 20, displayInline = false, expandState }: IStatusIconProps) {
    const paddingLeft = 3;
    const inlineAdder = 5;

    const background = info.altColor
        ? `linear-gradient(315deg, ${info.color} 50%, ${info.altColor} 50%)`
        : info.color;

    if (displayInline) {
        return (
            <div style={{ display: (displayInline) ? "inline-block" : "block" }}>
                <div style={{
                    width: (diameter + inlineAdder) + 'px',
                    height: (diameter + inlineAdder) + 'px',
                    background: background,
                    borderRadius: '50%',
                    border: info.border ?? 'none',
                    display: (displayInline) ? "inline-block" : "block",
                    position: "relative",
                    top: "0px"
                }}
                >&nbsp;</div>
                {displayInline ? (
                    <span style={{ paddingLeft: paddingLeft + "px" }}>{info.text}</span>
                ) : (<></>)
                }
            </div>
        );
    }
    else {
        return (
            <div style={{
                width: diameter + 'px',
                height: diameter + 'px',
                background: background,
                borderRadius: '50%',
                border: info.border ?? 'none',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // The glyph is drawn rather than lettered so it stays centered and crisp at any
                // diameter, and so a font change can't shift it.
                color: '#fff',
                flex: '0 0 auto'
            }}
                title={info.text}>
                {expandState && (
                    <svg width={diameter} height={diameter} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                        <line x1="7" y1="12" x2="17" y2="12" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
                        {expandState === "collapsed" && (
                            <line x1="12" y1="7" x2="12" y2="17" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
                        )}
                    </svg>
                )}
            </div>
        );
    }
}